module.exports = __webpack_public_path__ + "static/Muli-Black-b474a24acc0cae421ff61df53d55cede.ttf";